import { createReducer, on } from '@ngrx/store';
import * as ExtraExpensesActions from './extra-expenses.actions';
import { initialExtraExpensesState } from './extra-expenses.state';

export const extraExpensesReducer = createReducer(
  initialExtraExpensesState,

  on(ExtraExpensesActions.loadExpenses, (state, { params }) => ({
    ...state,
    params: { ...state.params, ...params },
    loading: true,
    error: null,
  })),

  on(ExtraExpensesActions.loadExpensesSuccess, (state, { response }) => ({
    ...state,
    expenses: response.items,
    total: response.total,
    page: response.page,
    limit: response.limit,
    totalPages: response.totalPages,
    loading: false,
    error: null,
  })),

  on(ExtraExpensesActions.loadExpensesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ExtraExpensesActions.createExpense, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ExtraExpensesActions.createExpenseSuccess, (state, { expense }) => ({
    ...state,
    expenses: [ ...state.expenses, expense ],
    loading: false,
    error: null,
  })),

  on(ExtraExpensesActions.createExpenseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ExtraExpensesActions.updateExpense, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ExtraExpensesActions.updateExpenseSuccess, (state, { expense }) => ({
    ...state,
    expenses: state.expenses.map(item => item.id === expense.id ? expense : item),
    loading: false,
    error: null,
  })),

  on(ExtraExpensesActions.updateExpenseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ExtraExpensesActions.deleteExpense, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ExtraExpensesActions.deleteExpenseSuccess, (state, { id }) => ({
    ...state,
    expenses: state.expenses.filter(item => item.id !== id),
    loading: false,
    error: null,
  })),

  on(ExtraExpensesActions.deleteExpenseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
